<template lang="html">
  <div class="recruit">
    <div class="content" v-if='code >= 0'>
      <div class="con" v-for="(a, index) in enrollmentList.data" :key="index">
        <div class="cardTop">
          <div class="recruitPosition">
            <p class="recruitTxt">{{a.position_name}}</p>
            <p class="recruitProceed" v-show="a.status == 1">· 进行中</p>
            <p class="recruitOver" v-show="a.status == 2">· 已结束</p>
          </div>
          <div class="recruitPay">
            {{a.salary}}
          </div>
        </div>
          
        <div class="cardCenter">
          <div class="recruitCondition">
            <div v-if="a.education == 1">不限</div>
            <div v-if="a.education == 2">初中及以下</div>
            <div v-if="a.education == 3">中专/中技</div>
            <div v-if="a.education == 4">高中</div>
            <div v-if="a.education == 5">大专</div>
            <div v-if="a.education == 6">本科</div>
            <div v-if="a.education == 7">硕士</div>
            <div v-if="a.education == 8">博士</div>
            <p v-for="b in a.keyword_ids.slice(0,3)" :key="b.kid">
              {{b.keywords}}
            </p>
          </div>
          <div class="recruitCapacity">
            能力值>{{a.capability_value}}
          </div>
        </div>
        
        <div class="cardBottom">
          <div class="recruitEnterprise">
            <div class="teacherImg">
              <img :src="a.avatar" alt="" class="teacherHead">
              <img src="@/assets/image/icon/pv.png" alt="" class="teacherMark">
            </div>
            <p class="recruitName">{{a.username}}</p>
          </div>
          <p class="recruitPlace">{{a.city}} {{a.area}}</p>
        </div>
        
        <WxOpenTag ref="wxopentag" :extinfo="'recruit/detail?id=' + a.recruit_id"/>
      </div>
    </div>
    
    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
      </div>
      <p>暂无内容哦~</p>
    </div>
  </div>
</template>

<script>
  import WxOpenTag from '@/components/WxOpenTag';
  import {pagebase} from '@/utils/http.js';
  
  export default {
    data(){
      return {
        pagebase: pagebase,
        code: '',
        enrollmentList: {},
      }
    },
    
    components: {
      WxOpenTag,
    },
    
    mounted(){
      this.init();
    },
    
    methods: {
      init(){
        this.getEnrollmentList();
      },
      
      getEnrollmentList() {
        this.$http({
          url: '/eleom/getEnrollmentList',
          method: 'get',
          params: {
            uid: this.$route.query.uid,
            page: 1,
            limit: 10,
          }
        }).then(res => {
          this.code = res.code;
          if (res.code >= 0) {
            this.enrollmentList = res.data;
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>  
  .con {
    position: relative;
    box-sizing: border-box;
    padding: 1.5rem;
  }
  
  .cardTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .recruitPosition {
    display: flex;
    align-items: center;
  }
  
  .recruitTxt {
    max-width: 19rem;
    font-size: 1.6rem;
    font-weight: 600;
    color: #333;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .recruitProceed {
    font-size: 1.1rem;
    color: #35BB76;
    margin-left: .5rem;
    background: linear-gradient(to left, #DBF4E7, #FFFFFF);
    padding-right: 1rem;
  }
  
  .recruitOver {
    font-size: 1.1rem;
    color: #929292;
    margin-left: .5rem;
    background: linear-gradient(to left, #F5F2F1, #FFFFFF);
    padding-right: 1rem;
  }
  
  .recruitPay {
    font-weight: 600;
    font-size: 1.6rem;
    color: #F7443F;
  }
  
  .cardCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: .5rem;
  }
  
  .recruitCondition {
    display: flex;
    align-items: center;
  }
  
  .recruitCondition div{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.1rem;
    color: #7B8D87;
    padding-right: .8rem;
    margin-right: .8rem;
    border-right: .01rem solid #7B8D87;
  }
  
  .recruitCondition p {
    box-sizing: border-box;
    padding: .2rem .75rem;
    max-width: 7rem;
    margin-right: .75rem;
    font-size: 1.1rem;
    color: #7B8D87;
    background-color: #F5F5F7;
    border-radius: .4rem;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  
  .recruitCapacity {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    height: 2rem;
    padding: 0 .75rem;
    font-size: 1.1rem;
    color: #F7443F;
    background-color: #FFF3F3;
    border-radius: .4rem;
  }
  
  .cardBottom {
    display: flex;
    justify-content: space-between;
    margin-top: .9rem;
  }
  
  .recruitEnterprise {
    display: flex;
    align-items: center;
  }
  
  .teacherImg {
    position: relative;
    height: 2.1rem;
    margin-right: .5rem;
  }
  
  .teacherHead {
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 2.1rem;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .teacherImg > .teacherMark {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1rem;
    height: 1rem;
  }
  
  .recruitName {
    font-size: 1.2rem;
    color: #333333;
  }
  
  .recruitPlace {
    font-size: 1.2rem;
    color: #999999;
  }
  
  /* 缺省页 */
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
